import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';

const STABLE_BRAND_COLORS = [
  '#FF6B35',
  '#4A90E2',
  '#7ED321',
  '#F7931E',
  '#9B59B6',
  '#E74C3C',
  '#1ABC9C',
  '#34495E',
  '#F39C12',
];

export interface BrandLogoProps {
  size?: number;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ size = 64 }) => {
  const logoSize = size;
  const puzzleSize = size * 0.5625;
  const pieceSize = puzzleSize / 3.6;

  return (
    <View
      style={StyleSheet.flatten([
        styles.logoContainer,
        {
          width: logoSize,
          height: logoSize,
          borderRadius: logoSize / 2,
        },
        // platform-specific: use boxShadow on web, keep shadowRadius on native
        Platform.OS === 'web'
          ? { boxShadow: `0 0 ${Math.round(logoSize * 0.24)}px rgba(255,107,53,0.42)` }
          : { shadowRadius: logoSize * 0.24 },
      ])}
    >
      <View
        style={StyleSheet.flatten([
          styles.puzzleGrid,
          {
            width: puzzleSize,
            height: puzzleSize,
          },
        ])}
      >
        {STABLE_BRAND_COLORS.map((color, index) => (
          <View
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            style={StyleSheet.flatten([
              styles.puzzlePiece,
              {
                width: pieceSize,
                height: pieceSize,
                backgroundColor: color,
              },
            ])}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  logoContainer: Platform.select({
    web: {
      backgroundColor: '#FFFFFF',
      alignItems: 'center',
      justifyContent: 'center',
      // boxShadow is applied inline per-size above for better control
    },
    default: {
      backgroundColor: '#FFFFFF',
      alignItems: 'center',
      justifyContent: 'center',
      shadowColor: '#FF6B35',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.42,
      elevation: 10,
    },
  }),
  puzzleGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  puzzlePiece: Platform.select({
    web: {
      borderRadius: 2,
      boxShadow: '0 1px 2px rgba(0,0,0,0.12)'
    },
    default: {
      borderRadius: 2,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.18,
      shadowRadius: 1.2,
      elevation: 2,
    }
  }),
});

export default BrandLogo;
